import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TicketService } from '../../services/ticket-service';
import { TicketCategory } from '../../models/entities/ticket-category-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'ticket-type-lov',
    templateUrl: './ticket-type-lov.component.html',
    styleUrls: ['./ticket-type-lov.component.scss']
})

export class TicketTypeLovComponent extends GenericLovComponent {

    ticketCategorys     : TicketCategory[] = [];
    code       : string;

    columns = [
      {  prop: 'ticketCategoryCode',    name: 'Code'},
      {  prop: 'name',                  name: 'Name' }
    ]

  ticketTypeColumns = [
    {  prop: 'ticketTypeCode',    name: 'Code'},
    {  prop: 'name',              name: 'Name' }
  ]

  constructor(
    public dialogRef: MatDialogRef<TicketTypeLovComponent>,
    protected ticketService : TicketService,
    protected toastr: ToastrService,
    protected router: Router,
    protected location : Location) {
      super();
  }
  

 //----------------------------------------------------------------------------------------------------------------
  loadData() {
      this.ticketService.ticketCategorysGet().then(ticketCategorys => {
        this.ticketCategorys   = ticketCategorys;
        if (ticketCategorys.length > 0) this.selectedTicketCategory = ticketCategorys[0];
    });
  }

  selectedTicketCategory : TicketCategory = null;
  selectTicketCategory(ticketCategory : TicketCategory ){
    this.selectedTicketCategory = ticketCategory;
  }
 //----------------------------------------------------------------------------------------------------------------
  

//----------------------------------------------------------------------------------------------------------------
  closeModal(ticketCategory : TicketCategory){
    this.dialogRef.close(ticketCategory);
  }
 //----------------------------------------------------------------------------------------------------------------
  
}
